import jQuery from 'jquery';
import babelPolyfill from '@babel/polyfill';
import './style.scss';

import Router from './util/Router';
import common from './routes/common';
import stronaGlowna from './routes/stronaGlowna';
import blog from './routes/blog';
import produkty from './routes/produkty';
import produkt from './routes/produkt';
import warsztat from './routes/warsztat';
import znajdzSerwis from './routes/znajdzSerwis';
import ofertaFlotowa from './routes/ofertaFlotowa';
import zostanPartnerem from './routes/zostanPartnerem';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 * Based on page body class
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page, note the change from strona główna to stronaGlowna. */
  stronaGlowna,
  /** Blog page */
  blog,
  /** Products page */
  produkty,
  /** Single product page */
  produkt,
  /** Garage page */
  warsztat,
  /** Map (find garage) page */
  znajdzSerwis,
  /** Fleet offer page */
  ofertaFlotowa,
  /** Become a partner page */
  zostanPartnerem
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());


// polyfills
/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
if (!Element.prototype.closest) {
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}
	Element.prototype.closest = function (s) {
		var el = this;
		var ancestor = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (ancestor.matches(s)) return ancestor;
			ancestor = ancestor.parentElement;
		} while (ancestor !== null);
		return null;
	};
}

// _mutation
// http://dom.spec.whatwg.org/#mutation-method-macro
function _mutation(nodes) { // eslint-disable-line no-unused-vars
	if (!nodes.length) {
		throw new Error('DOM Exception 8');
	} else if (nodes.length === 1) {
		return typeof nodes[0] === 'string' ? document.createTextNode(nodes[0]) : nodes[0];
	} else {
		var
		fragment = document.createDocumentFragment(),
		length = nodes.length,
		index = -1,
		node;

		while (++index < length) {
			node = nodes[index];

			fragment.appendChild(typeof node === 'string' ? document.createTextNode(node) : node);
		}

		return fragment;
	}
}

// Element.prototype.append
Document.prototype.append = Element.prototype.append = function append() {
	this.appendChild(_mutation(arguments));
};

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}
